module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Wintersingen-6dafbe3426bcea89f34210af30420df9.svg";